import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeModeContext } from '~theme-provider';
import Container from './Label/Container';
import Label from './Label/Label';
import buttonPropTypes from '../prop-types/buttonPropTypes';
import buttonStyles from '../styles/buttonStyles';
var AnchorButtonBase = styled.a.withConfig({
  displayName: "AnchorButton__AnchorButtonBase",
  componentId: "sc-1f1q2p9-0"
})(["", ""], buttonStyles);

var AnchorButton = function AnchorButton(_ref) {
  var path = _ref.path,
      icon = _ref.icon,
      size = _ref.size,
      block = _ref.block,
      skin = _ref.skin,
      btnType = _ref.btnType,
      iconSize = _ref.iconSize,
      iconColor = _ref.iconColor,
      children = _ref.children,
      target = _ref.target,
      isActive = _ref.isActive,
      buttonProps = _objectWithoutPropertiesLoose(_ref, ["path", "icon", "size", "block", "skin", "btnType", "iconSize", "iconColor", "children", "target", "isActive"]);

  var _useContext = useContext(ThemeModeContext),
      themeMode = _useContext.themeMode;

  var buttonContent = icon ? /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Label, {
    icon: icon,
    size: iconSize,
    color: iconColor,
    btnSize: size,
    skin: skin
  }, children)) : children;
  return /*#__PURE__*/React.createElement(AnchorButtonBase, Object.assign({
    href: path,
    sizeValue: size,
    blockValue: block,
    skin: skin,
    btnSize: size,
    btnType: btnType,
    target: target,
    rel: target === '_blank' ? 'noopener' : null,
    isActive: isActive,
    themeMode: themeMode
  }, buttonProps), buttonContent);
};

AnchorButton.defaultProps = {
  skin: 'primary',
  icon: undefined,
  iconColor: 'currentColor',
  iconSize: undefined,
  block: false,
  size: 'default',
  btnType: 'default',
  target: '_blank',
  children: undefined,
  isActive: false
};
export default AnchorButton;